import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import classNames from "classnames";
import { useHistory } from "react-router-dom";
// import InfiniteScroll from "react-infinite-scroll-component";
// import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
// import Favorite from "@material-ui/icons/Favorite";
import Parallax from "components/Parallax/Parallax.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Tooltip from "@material-ui/core/Tooltip";
import { TiArrowForward } from "react-icons/ti";
import { headApi } from "utils/headApi";
import { imgApi } from "utils/imgApi";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Spinner from "@material-ui/core/CircularProgress"
import Slide from "@material-ui/core/Slide";
import CornerRibbon from "react-corner-ribbon";

import productStyle from "assets/jss/material-kit-pro-react/views/productStyle.js";
import aboutUsStyle from "assets/jss/material-kit-pro-react/views/blogPostsPageStyle.js";
import popOver from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";

import BanglesHeader from "./Section/BanglesHeader.js";
import HeaderLink from "./Section/BanglesHeaderLink.js";
import BanglesFooter from "./Section/BanglesFooter.js";
import logo from "assets/img/examples/apple-bangles-org-icon.png";

const useStyles = makeStyles(productStyle);
const useStyle = makeStyles(aboutUsStyle);
const useStylPop = makeStyles(popOver);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function ProductStock() {
    const [prodList, setProdList] = React.useState([]);
    //   const [page, setpage] = React.useState(1);
    const [loginModal, setLoginModal] = React.useState(false);

    const classes = useStyles();
    const classe = useStyle();
    const classPop = useStylPop();
    const history = useHistory();

    const activeSession = sessionStorage.getItem("sessionData");

    useEffect(() => {
        fetch(headApi + `/products/stockedData?userid=1&active=1`)
            .then(res => res.json())
            .then(data => setProdList(data.ProductsData))

        setTimeout(hideAlertPop, 2000);
        setLoginModal(true)
    }, []);

    const hideAlertPop = () => {
        setLoginModal(false)
    };

    return (
        <div className={classes.productPage}>
            <Helmet>
                <title>Product Stock</title>
                <meta name="description" content="We make bangles with good quality raw material at factory prices.Bangles such as Gold Polished bangles, Die gold plated bangles, silver bangles, Micro Gold plated, rose gold plated bangles, 3tone bangles, Diamond Dell bangles, Rhodium bangles.We are basically working on customize designs and customise orders.you can get any sizes,colors, models and designs,we can make the bangles according to your requirements and needs. We are providing Zero making charges on bulk quantity orders (minimum purchase of 10 cartons)." />
                <meta name="keywords" content="fancy bangles, party wear bangles for women, stylish gold plated bangles, trendy gold bangles, imitation bangles, designer bangles, brass gold plated bangles, casual everyday bangles, elegant and beautiful bangles, finely polished, unique design angles,charming bangles, catchy designs" />
            </Helmet>
            <BanglesHeader
                brand="Home"
                links={<HeaderLink dropdownHoverColor="info" />}
                fixed
                color="transparent"
                changeColorOnScroll={{
                    height: 100,
                    color: "info",
                }}
            />
            <Parallax
                // image={require("assets/img/bg6.jpg").default}
                filter="dark"
                className={classes.pageHeader}
            >
                <div className={classe.container}>
                    <GridContainer justify="center">
                        <GridItem
                            md={8}
                            sm={8}
                            className={classNames(
                                classe.mlAuto,
                                classe.mrAuto,
                                classe.textCenter
                            )}
                        >
                            <h1 className={classe.title}>Product Stock</h1>
                            <h4 style={{ color: "white" }}>Here you will get to see our elegant collection of different designs, sizes and colors of bangles. These are our overall products which you can buy online as well as offline.</h4>
                        </GridItem>
                    </GridContainer>
                </div>
            </Parallax>
            <div className={classNames(classes.section, classes.sectionGray)}>
                <div className={classes.container}>
                    <Dialog
                        style={{ marginTop: "10%" }}
                        classes={{
                            root: classPop.modalRoot,
                            paper: classPop.modal + " " + classPop.modalLogin,
                        }}
                        open={loginModal}
                        TransitionComponent={Transition}
                        keepMounted
                        // onClose={() => setLoginModal(false)}
                        aria-labelledby="login-modal-slide-title"
                        aria-describedby="login-modal-slide-description"
                    >
                        <DialogTitle
                            id="login-modal-slide-title"
                            disableTypography
                            className={classPop.modalHeader}
                        >
                            <h5>Loading...</h5>
                            <DialogContent
                                id="login-modal-slide-description"
                                className={classPop.modalBody}
                            >
                                <GridContainer justify="center">
                                    <Spinner onChange={() => hideAlertPop()} style={{ color: "#00acc1" }} />
                                </GridContainer>
                                <br />
                            </DialogContent>
                        </DialogTitle>
                    </Dialog>
                    <div className={classes.relatedProducts}>
                        <h3 className={classNames(classes.title, classes.textCenter)}>
                            You may also be interested in:
                        </h3>
                        {/* <InfiniteScroll
              dataLength={prodList.length}
              next={fetchData}
              hasMore={true}
            > */}
                        <div className={classes.container}>
                            <GridContainer>
                                {prodList &&
                                    prodList.map((prod) => (
                                        <GridItem sm={6} md={3} key={prod.id}>
                                            <Card product>
                                                <CardHeader image>
                                                    <CornerRibbon
                                                        position={prod.total > 0 ? "top-left" : "top-right"}
                                                        // position="top-right" // OPTIONAL, default as "top-right"
                                                        fontColor="#f0f0f0" // OPTIONAL, default as "#f0f0f0"
                                                        backgroundColor="#00acc1" // OPTIONAL, default as "#2c7"
                                                        containerStyle={{}} // OPTIONAL, style of the ribbon
                                                        style={{ fontSize: "13px", fontWeight: "bold" }} // OPTIONAL, style of ribbon content
                                                        className="" // OPTIONAL, css class of ribbon
                                                    > {prod.total > 0 ? "In Stock" : "Make To Order"}
                                                    </CornerRibbon>
                                                    <p
                                                        style={{
                                                            position: "absolute",
                                                            left: "90%",
                                                            top: "90%",
                                                            transform: "translate(-50%, -50%)",
                                                        }}
                                                    >
                                                        <Tooltip
                                                            id="tooltip-tops"
                                                            title="Share to WhatsApp"
                                                            placement="top"
                                                            classes={{ tooltip: classes.tooltip }}
                                                        >
                                                            <a
                                                                href={`https://api.whatsapp.com/send/?phone=${prod.user.whatsapp
                                                                    }&text=https://inshabangles.com/bangles-product?id=${prod.id
                                                                    }%20${prod.banglessizemm.description
                                                                    }%20${prod.plating.description.slice(
                                                                        8
                                                                    )}&app_absent=0`}
                                                            >
                                                                {imgApi + "" + prod.design1.image1 !==
                                                                    imgApi + "" + "/crop_img/null" ? (
                                                                    <TiArrowForward size={50} color="#00acc1" />
                                                                ) : imgApi + "" + prod.design2.image2 !==
                                                                    imgApi + "" + "/crop_img/null" ? (
                                                                    <TiArrowForward size={50} color="#00acc1" />
                                                                ) : imgApi + "" + prod.design3.image3 !==
                                                                    imgApi + "" + "/crop_img/null" ? (
                                                                    <TiArrowForward size={50} color="#00acc1" />
                                                                ) : imgApi + "" + prod.design4.image4 !==
                                                                    imgApi + "" + "/crop_img/null" ? (
                                                                    <TiArrowForward size={50} color="#00acc1" />
                                                                ) : imgApi + "" + prod.design5.image5 !==
                                                                    imgApi + "" + "/crop_img/null" ? (
                                                                    <TiArrowForward size={50} color="#00acc1" />
                                                                ) : imgApi + "" + prod.design6.image6 !==
                                                                    imgApi + "" + "/crop_img/null" ? (
                                                                    <TiArrowForward size={50} color="#00acc1" />
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </a>
                                                        </Tooltip>
                                                    </p>

                                                    {prod.design1.img1active === 1 ? (
                                                        <img src={imgApi + "" + prod.design1.image1} alt="img1active" />
                                                    ) : prod.design2.img2active === 1 ? (
                                                        <img src={imgApi + "" + prod.design2.image2} alt="img2active" />
                                                    ) : prod.design3.img3active === 1 ? (
                                                        <img src={imgApi + "" + prod.design3.image3} alt="img3active" />
                                                    ) : prod.design4.img4active === 1 ? (
                                                        <img src={imgApi + "" + prod.design4.image4} alt="img4active" />
                                                    ) : prod.design5.img5active === 1 ? (
                                                        <img src={imgApi + "" + prod.design5.image5} alt="img5active" />
                                                    ) : prod.design6.img6active === 1 ? (
                                                        <img src={imgApi + "" + prod.design6.image6} alt="img6active" />
                                                    ) : (
                                                        ""
                                                    )}
                                                    <p
                                                        style={{
                                                            position: "absolute",
                                                            top: "65%",
                                                            left: "50%",
                                                            width: "65px",
                                                            height: "65px",
                                                            transform: "translate(-50%, -50%)",
                                                        }}
                                                    >
                                                        {imgApi + "" + prod.design1.image1 !==
                                                            imgApi + "" + "/crop_img/null" ? (
                                                            <img src={logo} alt="logo1" />
                                                        ) : imgApi + "" + prod.design2.image2 !==
                                                            imgApi + "" + "/crop_img/null" ? (
                                                            <img src={logo} alt="logo2" />
                                                        ) : imgApi + "" + prod.design3.image3 !==
                                                            imgApi + "" + "/crop_img/null" ? (
                                                            <img src={logo} alt="logo3" />
                                                        ) : imgApi + "" + prod.design4.image4 !==
                                                            imgApi + "" + "/crop_img/null" ? (
                                                            <img src={logo} alt="logo4" />
                                                        ) : imgApi + "" + prod.design5.image5 !==
                                                            imgApi + "" + "/crop_img/null" ? (
                                                            <img src={logo} alt="logo5" />
                                                        ) : imgApi + "" + prod.design6.image6 !==
                                                            imgApi + "" + "/crop_img/null" ? (
                                                            <img src={logo} alt="logo6" />
                                                        ) : (
                                                            ""
                                                        )}
                                                    </p>
                                                </CardHeader>
                                                <h6
                                                    className={classNames(
                                                        classes.cardCategory,
                                                        classes.textRose
                                                    )}
                                                >
                                                    {prod.plating.description.slice(8) +
                                                        " " +
                                                        prod.cat.description}{" "}
                                                    <br /> {prod.banglessizemm.description}{" "}
                                                    {prod.itemcode}-{prod.id}
                                                </h6>
                                            </Card>
                                            <Card>
                                                <CardBody>
                                                    <div className={classes.cardDescription}>
                                                        {(
                                                            prod.metalOption.readygram * prod.sets.pcs
                                                        ).toFixed(4)}{" "}
                                                        Avg Gram Of {prod.sets.setdesc} {"and "}
                                                        {prod.box.boxdesc}
                                                        {","} {prod.ctndescription}
                                                        {"."}<br />
                                                        <h5 style={{ color: "black" }}>Boxs: {prod.total}</h5>
                                                    </div>
                                                </CardBody>
                                                <CardFooter className={classes.justifyContentBetween}>
                                                    <div className={classes.price}>
                                                        {!activeSession ? <h5 style={{ color: "black" }}>
                                                            Price{" "}
                                                            <span>
                                                                ₹{" "}
                                                                {(
                                                                    prod.taxCalculation.cash / prod.box.box
                                                                ).toFixed(2)}
                                                                /-*
                                                            </span>
                                                        </h5> : <h5 style={{ color: "black" }}>
                                                            Price{" "}
                                                            <span>
                                                                ₹{" "}
                                                                {(
                                                                    prod.taxCalculation.cash / prod.box.box
                                                                ).toFixed(2)}
                                                                /-*
                                                            </span>
                                                        </h5>}

                                                    </div>
                                                    {/* <div className={classes.stats}>
                                                        <Tooltip
                                                            id="tooltip-top"
                                                            title="Save to Wishlist"
                                                            placement="top"
                                                            classes={{ tooltip: classes.tooltip }}
                                                        >
                                                            <Button justIcon color="rose" simple>
                                                                <Favorite />
                                                            </Button>
                                                        </Tooltip>
                                                    </div> */}
                                                </CardFooter>
                                                <CardFooter className={classes.justifyContentBetween}>
                                                    <div className={classes.price}>
                                                        <Button
                                                            color="info"
                                                            onClick={() => history.push({
                                                                pathname: `/order-stock`,
                                                                state: prod.id
                                                            })}
                                                        >
                                                            Buy Now
                                                        </Button>
                                                    </div>
                                                </CardFooter>
                                            </Card>
                                        </GridItem>
                                    ))}
                            </GridContainer>
                        </div>
                        {/* </InfiniteScroll> */}
                    </div>
                </div>
            </div>
            <BanglesFooter />
        </div>
    );
}